// extracted by mini-css-extract-plugin
export default {"sectionTitle":"Popular_sectionTitle__Mk7vK","trendingList":"Popular_trendingList__zKZ62"};